__turbopack_context__.v({
  "baseCurrency": "index-module-scss-module__znymsW__baseCurrency",
  "currency": "index-module-scss-module__znymsW__currency",
  "divider": "index-module-scss-module__znymsW__divider",
  "focused": "index-module-scss-module__znymsW__focused",
  "input": "index-module-scss-module__znymsW__input",
  "percent": "index-module-scss-module__znymsW__percent",
  "usdt": "index-module-scss-module__znymsW__usdt",
  "wrapper": "index-module-scss-module__znymsW__wrapper",
});
